"use client";
import React from "react";

import useStore from "../../../lib/Store/useStore";
import NewCardText from "../../Atoms/Typography/NewCardText";
import {
    CARD_DISCRIPTION_CLASS,
    CARD_HEADING_CLASS,
    CARD_INDEX_CLASS,
    CARD_SUBTEXT_CLASS,
    CARD_WRAPPER_CLASS,
    updateDescription,
} from "./constants";

const HowWeWorksCard = ({
    step,
    heading,
    description,
    image,
    index,
    arabic_order_class,
    orientation = "horizontal",
    haveButton = false,
    subText,
}) => {
    const { currency, price } = useStore();
    return (
        <div className={CARD_WRAPPER_CLASS(orientation)} key={index}>
            <NewCardText text={step} className={CARD_INDEX_CLASS} />
            <div className="ml-8 sm:ml-0 flex flex-col items-start sm:items-center">
                {heading && (
                    <NewCardText
                        text={heading}
                        className={
                            CARD_HEADING_CLASS(haveButton) +
                            " text-left sm:text-center"
                        }
                    />
                )}
                {subText && (
                    <NewCardText
                        text={subText}
                        className={
                            CARD_SUBTEXT_CLASS + " !text-left sm:!text-center"
                        }
                    />
                )}
                <NewCardText
                    text={updateDescription(description, currency, price)}
                    className={
                        CARD_DISCRIPTION_CLASS + " !text-left sm:!text-center"
                    }
                />
            </div>
        </div>
    );
};

export default HowWeWorksCard;
